import { useState, useEffect } from 'react'
import styles from "./Message.module.css"

function Message({ msg }) {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (!msg) {
            setVisible(false)
            return
        }
        
        setVisible(true)

        const timer = setTimeout(() => {
            setVisible(false)
        }, 2000)

        return () => clearTimeout(timer)
    }, [msg])  

    return (
        <>
            {visible && (
                <div className={styles.message}>{msg}</div>
            )}
        </>
    )
}

export default Message 